<template>
	<b-container class="w-75 text-dark">
		<b-row class="heading p-4">
			<b-col>
				<h3 class="text-center">Welcome to Learning Lab!</h3>
			</b-col>
		</b-row>
		<b-row class="my-4 mb-5">
			<b-col cols="2">
				<h3 class="step-number">1</h3>
			</b-col>
			<b-col>
				<p>To get started, select the course and Learning Lab you want to work with from the left navigation bar.</p>
				<img src="@/assets/welcome-step-1.png" />
			</b-col>
		</b-row>
		<b-row class="my-4 mb-5">
			<b-col cols="2">
				<h3 class="step-number">2</h3>
			</b-col>
			<b-col>
				<p>Once you have selected the course and Learning Lab you want to work with, you will see the list of machines that are available to you to complete your assignments. When you are ready to begin, click the <strong>Provision</strong> button.</p>
				<img src="@/assets/welcome-step-2.png" />
			</b-col>
		</b-row>
		<b-row class="my-4 mb-5">
			<b-col cols="2">
				<h3 class="step-number">3</h3>
			</b-col>
			<b-col>
				<p>Now that you have finished provisioning your Learning Lab, you may connect to the individual machines that contain the software you need. If you have any questions, please visit the knowledge base or reach out to the support team.</p>
				<img src="@/assets/welcome-step-3.png" />
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	export default
	{
		name: 'home',
		data() { return {}; }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.step-number {
		min-width: 60px;
		min-height: 60px;
		max-width: 60px;
		max-height: 60px;
		
		border-radius: 2em;
		
		border: 3px solid var(--dark);
		
		align-items: center;
		justify-content: center;
		text-align: center;
		
		font-size: 60px;
		font-size: 2.75rem;
		font-weight: bold;
    }
    
	.fade-enter-active, .fade-leave-active
	{
		transition: all 1s;
	}
</style>
